const TipoAula = {
    COLETIVAS: 1,
    MUSCULACAO: 2
};
TipoAula.install = function (Vue) {
    Vue.prototype.$tipoAula = (key) => {
        return TipoAula[key];
    }
};
export default TipoAula;